import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import noop from 'hs-lodash/noop';
import { useState } from 'react';
import { Modal, Overlay } from '../styles/FullScreenSearch.styles';
import { useTypeahead } from '../utils/useTypeahead';
import { FullScreenSearchHeader } from './FullScreenSearchHeader';
import { FullScreenSearchResults } from './FullScreenSearchResults';

const FullScreenSearch = ({
  onClose,
  onSelectOption,
  onInputChange = noop,
  seleniumKey = 'full-screen-search',
  allOptions,
  preFillList,
  searchPlaceholder,
  searchAutofocus = true,
  renderOption,
  showOptionsWhenNullSearchValue,
  noMatchesOption = {
    text: '',
    value: '',
    help: ''
  },
  illustrationName = '',
  illustrationCaption = '',
  illustrationWidth = 60,
  loadOptions
}) => {
  const [inputValue, setInputValue] = useState('');
  const [filteredOptions, setOptions] = useState([]);
  const {
    getFilteredOptions
  } = useTypeahead(allOptions, noMatchesOption, loadOptions);

  const filterOptions = searchValue => {
    if (searchValue) {
      getFilteredOptions(searchValue).then(({
        options
      }) => {
        setOptions(options);
      }).catch(() => {
        setOptions([noMatchesOption]);
      });
    }
  };

  const handleSearchChange = event => {
    setInputValue(event.target.value);
    onInputChange(event.target.value);
    filterOptions(event.target.value);
  };

  return /*#__PURE__*/_jsx(Overlay, {
    children: /*#__PURE__*/_jsxs(Modal, {
      className: "m-x-auto",
      children: [/*#__PURE__*/_jsx(FullScreenSearchHeader, {
        searchAutofocus: searchAutofocus,
        searchPlaceholder: searchPlaceholder,
        seleniumKey: seleniumKey,
        onClose: onClose,
        onSearchChange: handleSearchChange
      }), /*#__PURE__*/_jsx(FullScreenSearchResults, {
        allOptions: allOptions,
        filteredOptions: filteredOptions,
        illustrationCaption: illustrationCaption,
        illustrationName: illustrationName,
        illustrationWidth: illustrationWidth,
        noMatchesOption: noMatchesOption,
        preFillList: preFillList,
        renderOption: renderOption,
        searchValue: inputValue,
        showOptionsWhenNullSearchValue: showOptionsWhenNullSearchValue,
        onSelectOption: onSelectOption
      })]
    })
  });
};

FullScreenSearch.defaultProps = {
  onClose: () => {},
  onSelectOption: () => {},
  onInputChange: () => {},
  options: {},
  preFillList: [],
  searchAutofocus: true,
  showOptionsWhenNullSearchValue: true,
  illustrationWidth: 60
};
export default FullScreenSearch;